export type AppRouteId = "shelf" | "search" | "reader" | "sources" | "users" | "monitor" | "backup" | "agent";

export interface AppRoute {
  id: AppRouteId;
  path: string;
  label: string;
  description: string;
}

export const appRoutes: AppRoute[] = [
  { id: "shelf", path: "/shelf", label: "书架", description: "默认入口" },
  { id: "search", path: "/search", label: "搜索", description: "在线查找" },
  { id: "reader", path: "/reader", label: "阅读", description: "章节正文" },
  { id: "sources", path: "/sources", label: "书源", description: "启用和检查" },
  { id: "users", path: "/users", label: "用户", description: "账号和授权" },
  { id: "monitor", path: "/monitor", label: "监控", description: "遥测状态" },
  { id: "backup", path: "/backup", label: "备份", description: "导出恢复" },
  { id: "agent", path: "/agent", label: "Agent", description: "LLM 接口" },
];

export function readRoute(pathname: string): AppRoute {
  return appRoutes.find(route => route.path === pathname) ?? appRoutes[0]!;
}

export function navigateTo(path: string): void {
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
